const state = {
  streamMap: new Map(),
  orderingRuleActive: 'state',
  classStatusStore: 'all',
  currentPageStore: 1,
  searchKeywordsStore: ''
}

const mutations = {
  setOrderingRuleActive (state, orderingRuleActive) {
    state.orderingRuleActive = orderingRuleActive
  },
  setClassStatusStore (state, classStatusStore) {
    state.classStatusStore = classStatusStore
  },
  setCurrentPageStore (state, currentPageStore) {
    state.currentPageStore = currentPageStore
  },
  setSearchKeywordsStore (state, searchKeywordsStore) {
    state.searchKeywordsStore = searchKeywordsStore
  },
  clearSearchState (state) {
    state.orderingRuleActive = 'state'
    state.classStatusStore = 'all'
    state.currentPageStore = 1
    state.searchKeywordsStore = ''
  }
}

const actions = {
  
}

const getters = {
  streamMap (state) {
    return state.streamMap
  },
  orderingRuleActive (state) {
    return state.orderingRuleActive
  },
  classStatusStore (state) {
    return state.classStatusStore
  },
  currentPageStore (state) {
    return state.currentPageStore
  },
  searchKeywordsStore (state) {
    return state.searchKeywordsStore
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}